import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;
import { IOneMessageJson } from "../../../../../nodeserver/structs/database.js";

import {    
    appearingFlexElement,
    disappearingElement,      
} from "../../messages/helpers.js";
import { EditActionElement } from "./actions/edit.js";
import { DeleteActionElement } from "./actions/delete.js";
import { DeleteSignElement, hideDeleteMessageSign, showDeleteMessageSign } from "./actions/delete-sign.js";
import { AnswerActionElement } from "./actions/answer.js";
import { HistoryActionElement } from "./actions/history.js";
import { ReportActionElement } from "./actions/report.js";
import { RestoreActionElement } from "./actions/restore.js";
import { HumburgerActionElement, rotateHumburger, setDefaultHumburgerPosition } from "./actions/humburger.js";

export function UserMessageActionsDetails(props: {
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>

}): HTMLElement {

    if (!user_id)
        return (<></>);

    const editElement = <EditActionElement message={props.message} msg={props.msg} withText={true}/>

    const deleteElement = <DeleteActionElement message={props.message} msg={props.msg} withText={true}/>;

    const historyElement = <HistoryActionElement message={props.message} msg={props.msg} showOn="viewed" withText={true}/>;

    const reportElement = <ReportActionElement message={props.message} msg={props.msg} withText={true}/>
    const answerElement = <AnswerActionElement message={props.message} msg={props.msg} withText={true}/>
    return (
        <div className="user-message-actions-details disappearing-element">
            {answerElement}
            {editElement}
            {deleteElement}
            {historyElement}
            {reportElement}
        </div>
    );
}






export function throwErrorIfActionsElementBlock(elementId: number) {
    if (blockedElements.includes(elementId))
        throw new Error("action is blocked");
}

export function blockActionsElementOrThrowErrorIfBlocked(elementId: number) {
    throwErrorIfActionsElementBlock(elementId);

    blockedElements.push(elementId);
}


export function unblockActionsElement(elementId: number) {
    const index = blockedElements.indexOf(elementId);

    if (index !== -1) {
        blockedElements.splice(index, 1);
    }
      
}


export function UserMessageActions(props: {
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>
}): HTMLElement {

    if (!user_id)
        return (<></>);


    

    const restoreMessageElement = <RestoreActionElement msg={props.msg}/>

    const deletedSign = <DeleteSignElement msg={props.msg}/>;
    const historyElement = <HistoryActionElement message={props.message} msg={props.msg} showOn="deleted" withText={false}/>;
    const editElement = <EditActionElement message={props.message} msg={props.msg} withText={false}/>
    const deleteElement = <DeleteActionElement message={props.message} msg={props.msg} withText={false}/>;
    const answerElement = <AnswerActionElement message={props.message} msg={props.msg} withText={false}/>
    const humburgerElement = <HumburgerActionElement message={props.message} msg={props.msg} />;
    const actionsInsert = [
        restoreMessageElement,
        historyElement,
        answerElement,
        editElement,
        editElement,
        deleteElement,
        humburgerElement
    ]
    const userMessageActionsElement = actionsInsert.some(el => el !== <></>) ?
        (
            <div className="user-message-actions disappearing-element">
                {...actionsInsert}
            </div>
        ) : <></>;
    const actions = (
        <>
            {deletedSign}
            {userMessageActionsElement}
        </>

    )

    return actions;
}






export function hideUserMessageActionsDetails(message: HTMLDivElement) {
    let userActionsDetailsElement = $(message).find(" .user-message-actions-details");
    hideUserMessageActionsDetailsPassElement(userActionsDetailsElement, message);
}



export function hideAllActions(message: HTMLDivElement) {
    showDeleteMessageSign(message);
    let userMessageActions = $(message).find(".user-message-actions");


    userMessageActions
        .removeClass(appearingFlexElement)
        .addClass(disappearingElement);


    hideUserMessageActionsDetails(message);
}




export function hideUserMessageActionsDetailsPassElement(userActionsDetailsElement: JQuery<HTMLElement>, message: HTMLDivElement) {

    userActionsDetailsElement.addClass(disappearingElement);

    setDefaultHumburgerPosition(message);
}




export function showMessageUserActions(message: HTMLDivElement) {
    
    const $message = $(message);
    if (!$message.hasClass("no-date") || !$message.hasClass("no-ava"))
        hideDeleteMessageSign(message);

    let userMessageActions = $message.find(".user-message-actions");


    userMessageActions.addClass(appearingFlexElement)
    userMessageActions.removeClass(disappearingElement);
}




export function showUserMessageActionsDetailsPassElement(userActionsDetailsElement: JQuery<HTMLElement>, message: HTMLDivElement) {
    let anotherActionDetailsElements = $(".user-message-actions-details").not("." + disappearingElement);

    userActionsDetailsElement.removeClass(disappearingElement);
    anotherActionDetailsElements.addClass(disappearingElement);

    rotateHumburger(message);
}

